import { render, staticRenderFns } from "./NewMediaTypeModal.vue?vue&type=template&id=d5814650&lang=pug&"
import script from "./NewMediaTypeModal.vue?vue&type=script&lang=js&"
export * from "./NewMediaTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports